import { render } from "./ui-button.vue?vue&type=template&id=0833d5ef&scoped=true"
import script from "./ui-button.vue?vue&type=script&lang=js"
export * from "./ui-button.vue?vue&type=script&lang=js"

import "./ui-button.vue?vue&type=style&index=0&id=0833d5ef&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0833d5ef"]])

export default __exports__